module.exports = __webpack_public_path__ + "img/编组 8@2x.6865e908.png";